'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdapterMultiSelect = function AdapterMultiSelect(props) {
  function onChange(target) {
    target = target.target;
    target.selectedOptions = target.selectedOptions.map(function (entry) {
      return isNaN(parseInt(entry.value)) ? entry.value : parseInt(entry.value);
    });
    props.onChange(target.name, target.selectedOptions);
  }

  var sortByProperty = props.sortByProperty;
  var options = props.options.slice().sort(function (a, b) {
    if (typeof a[sortByProperty] === 'string') return a[sortByProperty].localeCompare(b[sortByProperty]);
    return parseInt(a[sortByProperty]) - parseInt(b[sortByProperty]);
  });
  return /*#__PURE__*/_react.default.createElement(_index.MultiSelect, {
    t: props.t,
    label: props.label,
    name: props.name || '',
    onChange: onChange,
    list: options,
    value: props.items,
    errors: props.errors,
    readOnly: false,
    hasError: props.error
  });
};

AdapterMultiSelect.propTypes = {
  t: _propTypes.default.func,
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  options: _propTypes.default.any,
  items: _propTypes.default.any,
  errors: _propTypes.default.any,
  error: _propTypes.default.any,
  onChange: _propTypes.default.func,
  sort: _propTypes.default.bool,
  sortByProperty: _propTypes.default.string
};
AdapterMultiSelect.defaultProps = {
  sortByProperty: 'name'
};
var _default = AdapterMultiSelect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/adapter-multi-select.js
// module id = 540
// module chunks = 0